module.exports = __webpack_public_path__ + "static/media/CardLogin.35ee566b.gif";